/*
 * @FilePath: /mall-fe/src/views/h5/Home/components/Header.tsx
 * @Description: 移动端头部搜索组件
 *
 */
import React, { useContext } from 'react';
import Link from 'next/link';
import Arrows from 'icons/arrows';
import { cls } from 'reactutils';
import { useState, useCallback } from 'react';
import AreaPickerWithLevel from 'comps/AreaPickerWithLevel';
import MessageEntry from 'comps/MessageEntry';
import { Flex } from 'react-vant';
import T7 from 'icons/t7.svg';
import Bzcj from 'icons/bzcj.svg';
import Gktm from 'icons/gktm.svg';
import Pzbz from 'icons/pzbz.svg';
import IconFont from 'comps/IconFont';
import { MediaQueryContext } from '@/libs/contexts';
const ADVER_TIPS = [
  {
    title: 'T+7付款',
    IconComponent: T7,
  },
  {
    title: '不赚差价',
    IconComponent: Bzcj,
  },
  {
    title: '公开透明',
    IconComponent: Gktm,
  },
  {
    title: '品质保障',
    IconComponent: Pzbz,
  },
];
const MOBILE_ADVER_TIPS = [
  {
    title: 'T+7付款',
    IconComponent: T7,
  },
  {
    title: '公开透明',
    IconComponent: Gktm,
  },
  {
    title: '品质保障',
    IconComponent: Pzbz,
  },
];
// 跳转热点商品
const link = '/hot-search';
function AdvertisementEle(props) {
  const TIPS = props?.isMobile ? MOBILE_ADVER_TIPS : ADVER_TIPS;
  return (
    <div className="adver-main">
      <Flex>
        {TIPS.map(({ title, IconComponent }, i) => (
          <Flex.Item key={i} span={props?.isMobile ? 8 : 6}>
            {React.createElement(IconComponent, {
              className: 'rv-flexitem-child',
            })}
            <span className="adver-text rv-flexitem-child">{title}</span>
          </Flex.Item>
        ))}
      </Flex>
      <style jsx>{`
        .adver-main {
          padding: 0 15px;
          opacity: 0.7;
        }
        .adver-main :global(.rv-flexitem) {
          text-align: center;
        }
        .adver-main :global(.rv-flexitem-child) {
          vertical-align: middle;
        }

        .adver-text {
          margin-left: 5px;
          font-size: 10px;
          letter-spacing: 0;
          line-height: 16px;
          color: #fff;
        }
      `}</style>
    </div>
  );
}

function Header() {
  const { isMobile } = useContext(MediaQueryContext); // 是否为移动端
  // 默认配货区域
  const [areaName, setAreaName] = useState<string>('');
  // 地区选择器显隐控制
  const [showAreaPicker, setShowAreaPicker] = useState<boolean>(false);

  // 初始化修改当前区域
  const handleAreaChange = useCallback(async (areaData: Array<{ sysNo: string; name: string }>) => {
    // 获取最后一个元素的
    setAreaName(areaData[areaData.length - 1]?.name);
    setShowAreaPicker(false);
  }, []);

  // 地区选择器
  const AreaSelectionEle = (
    <div className="area-selection" onClick={() => !showAreaPicker && setShowAreaPicker(true)}>
      <span className="area-name">{areaName}</span>
      <span className={cls('arrow', showAreaPicker && 'show')}>
        <Arrows />
      </span>
      <AreaPickerWithLevel
        visible={showAreaPicker}
        onClose={() => setShowAreaPicker(false)}
        onChange={handleAreaChange}
        areaLevel={2}
        onInit={handleAreaChange}
        enableIPSwitch={true}
      />
      <style jsx>
        {`
          .area-name {
            color: #fff;
          }

          .arrow {
            padding: 0 6px;
            transition: all;
            display: inline-block;
            transform: translateY(-1px);
          }

          .arrow.show :global(svg) {
            transform: rotateZ(180deg);
          }
        `}
      </style>
    </div>
  );

  const SearchEle = (
    <Link href={link}>
      <div className="search-content">
        {IconFont('icon-mobile-footer-nav-Search')}
        <span className="search-placeholder">搜索商品/商机/店铺</span>
        <style jsx global>
          {`
            .search-content {
              flex: 1;
              background: #fff;
              border-radius: 90px;
              height: 27px;
              line-height: 27px;
              color: #ccc;
              padding-left: 12px;
            }

            .search-placeholder {
              font-size: 12px;
              padding-left: 8px;
            }

            .icon-mobile-footer-nav-Search {
              vertical-align: bottom;
            }
          `}
        </style>
      </div>
    </Link>
  );
  return (
    <div className="header-content">
      <div className="header-filter-box">
        {AreaSelectionEle}
        {SearchEle}
        <MessageEntry />
      </div>
      <AdvertisementEle isMobile={isMobile} />
      <style jsx>
        {`
          .header-filter-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px;
          }
        `}
      </style>
    </div>
  );
}

export default Header;
